import { render } from "../templates/partner-grid.html?vue&type=template&id=363bc973"
import script from "./partner-grid.vue?vue&type=script&lang=js"
export * from "./partner-grid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__